import { Button, Dialog } from '@/components/UI'
import type { ApplicationFormFieldData } from '@/schemas/v2'

type Props = {
  opened: boolean
  onClose: () => void
  onConfirm: () => void
  /** 確認表示する応募フォームデータ */
  formData?: Record<string, string | string[]>
  /** フォームフィールド定義（ラベル表示用） */
  fields?: ApplicationFormFieldData[]
}

/**
 * 応募確認ダイアログ。
 * 応募前に入力内容を確認させる確認ステップ。
 * Figma: node 561-22470
 */
export function DialogV2ApplyConfirm({ opened, onClose, onConfirm, formData, fields = [] }: Props) {
  return (
    <Dialog selectorState={opened} closeFunc={onClose} title="応募内容の確認">
      <div className="flex flex-col gap-4 px-4 py-6">
        <p className="text-center text-[13px] leading-[20px] text-gray-600">
          以下の内容で応募します。
          <br />
          よろしいですか？
        </p>
        {formData && fields.length > 0 && (
          <div className="rounded-[8px] border border-gray-200 p-4 flex flex-col gap-2">
            {[...fields]
              .sort((a, b) => a.sortOrder - b.sortOrder)
              .map((field) => {
                const value = formData[field.fieldKey]
                if (!value || (Array.isArray(value) && value.length === 0)) return null
                const displayValue = Array.isArray(value) ? value.join('、') : value
                return (
                  <div key={field.fieldKey} className="flex flex-col gap-0.5">
                    <span className="text-[12px] leading-[18px] text-gray-500">{field.label}</span>
                    <span className="text-[14px] leading-[20px] text-black">{displayValue}</span>
                  </div>
                )
              })}
          </div>
        )}
        <Button label="確認して応募する" variant="primary" size="md" fullWidth onClick={onConfirm} />
        <button
          type="button"
          className="flex h-[48px] w-full items-center justify-center rounded-[8px] border border-gray-300 text-[15px] font-bold text-gray-600"
          onClick={onClose}
        >
          戻る
        </button>
      </div>
    </Dialog>
  )
}
